import Vue from "vue";
import VueRouter from "vue-router";

import Dashboard from "@/views/Dashboard";
import AppsIndex from "@/views/Apps/Index";

import authenticationRoutes from "./authentication.routes";
import zendeskRoutes from "./zendesk.routes";
import integrationsRoutes from "./integrations.routes";

import translationsRoutes from "./apps/translations.routes";

// END: Dashboard Views

Vue.use(VueRouter);

export default new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    {
      path: "/",
      name: "Dashboard",
      component: Dashboard,
      redirect: "/apps",
      children: [
        {
          path: "apps",
          name: "AppsMain",
          component: AppsIndex,
        },
        ...translationsRoutes,
        ...integrationsRoutes,
      ],
    },

    ...authenticationRoutes,
    ...zendeskRoutes,

    {
      path: "*",
      beforeEnter() {
        location.href =
          process.env.VUE_APP_MODE == "development"
            ? "http://localhost:8080"
            : "https://apps.getmacha.com";
      },
    },
  ],
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    }
  },
});
